import { updateRunsheetShiftTableState } from '@/entities/gridTables/thunks/updateRunsheetShiftTableState'
import { runsheetShiftsSelectors, StopTypeEnum } from '@/entities/schedules'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { ordersSelectors } from '../ordersSelectors'
import { fetchRunsheetOrders } from './fetchRunsheetOrders'

type FetchOrdersByShiftPayload = {
  shiftId: EntityId
  forceRefresh?: boolean
}

export const fetchRunsheetOrdersByShift = createAsyncThunk<void, FetchOrdersByShiftPayload, ThunkApiContext>('orders/fetchRunsheetOrdersByShift',
  async ({ shiftId, forceRefresh }, { dispatch, getState }) => {
    const state = getState()
    const runsheetShift = runsheetShiftsSelectors.selectById(state, shiftId)

    if (runsheetShift.loads && runsheetShift.loads.length > 0) {
      const orderIds = runsheetShift.loads
        .flatMap(load => load.stops.map(stop => stop.stopType === StopTypeEnum.Order ? stop.orderId : undefined))
        .filter((orderId) => orderId !== undefined)
        .filter((orderId) => forceRefresh ? true : (orderId && !ordersSelectors.selectById(state, orderId)))

      if (orderIds.length > 0) {
        await dispatch(fetchRunsheetOrders({ orderIds }))
      }
    }

    // Update the runsheet shift table state
    await dispatch(updateRunsheetShiftTableState({ shiftId }))
  },
)
